var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCareer1 = function SvgCareer1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1.333 21.555h20.912m-10.456 0v2.614m13.567-6.773a8.333 8.333 0 1 0-11.28-8.888m15.788-2.45h-1.579a2.58 2.58 0 0 0-2.38 2.38v2.221c0 .541-.794.96-1.21 1.344l-1.71 1.568M20.443 1.512s1.389 1.095 1.897 1.486a1.98 1.98 0 0 1 .375 2.754L21.52 7.346a1.97 1.97 0 0 1-1.581.791h-1.16a1.98 1.98 0 0 0-1.398.58l-.495.494M3.947 16.328h15.684s2.614 0 2.614 2.614v9.149s0 2.614-2.614 2.614H3.947s-2.614 0-2.614-2.614v-9.15s0-2.613 2.614-2.613m11.763 0H7.868l.472-2.829a1.31 1.31 0 0 1 1.289-1.092h4.32a1.31 1.31 0 0 1 1.29 1.092z",
    vectorEffect: "non-scaling-stroke"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgCareer1;